import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs';
import { CompareFacadeService } from 'src/app/core/+store/compare/compare.facade';
import { SavedFacadeService } from 'src/app/core/+store/saved/saved.facade';

@UntilDestroy()
@Component({
  selector: 'tad-saved-dialog',
  templateUrl: './saved-dialog.component.html',
  styleUrls: ['./saved-dialog.component.scss']
})
export class SavedDialogComponent implements OnInit {
  public institutions$ = this.savedFacadeService.institutions$;

  public compareInstitutionIds$ = this.compareFacadeService.institutions$.pipe(
    map((institutions) => (institutions || []).map((item) => item?.id))
  );

  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<SavedDialogComponent>,
    private compareFacadeService: CompareFacadeService,
    private savedFacadeService: SavedFacadeService
  ) {}

  public ngOnInit(): void {
    this.router.events.pipe(untilDestroyed(this)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.dialogRef.close();
      }
    });
  }
}
